<div class="skeletor-req">
  <div class="skeletor-req-header">
    <p-skeleton [width]="'16rem'" [height]="'1.2rem'" />
    <p-skeleton [width]="'24rem'" [height]="'1rem'" />
  </div>

  <div class="skeletor-req-panel">
    <div class="skeletor-req-toolbar">
      <div>
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <p-skeleton [width]="'20rem'" [height]="'0.9rem'" />
      </div>
      <p-skeleton [width]="'12rem'" [height]="'2.2rem'" />
    </div>

    <div class="skeletor-req-subheader">
      <p-skeleton [width]="'10rem'" [height]="'1rem'" />
      <div class="skeletor-chip-row">
        <p-skeleton [width]="'6rem'" [height]="'1.5rem'" />
      </div>
    </div>

    <div class="skeletor-req-list">
      <div class="skeletor-req-item" *ngFor="let i of rows">
        <div class="skeletor-req-item-head">
          <p-skeleton [width]="'12rem'" [height]="'1rem'" />
          <div class="skeletor-chip-row">
            <p-skeleton [width]="'7rem'" [height]="'1.4rem'" />
            <p-skeleton [width]="'6rem'" [height]="'1.4rem'" />
          </div>
        </div>
        <div class="skeletor-req-item-meta">
          <p-skeleton [width]="'8rem'" [height]="'0.9rem'" />
          <p-skeleton [width]="'10rem'" [height]="'0.9rem'" />
          <p-skeleton [width]="'12rem'" [height]="'0.9rem'" />
        </div>
      </div>
    </div>
  </div>

  <div class="skeletor-req-subheader">
    <p-skeleton [width]="'12rem'" [height]="'1rem'" />
    <div class="skeletor-chip-row">
      <p-skeleton [width]="'7rem'" [height]="'1.4rem'" />
    </div>
  </div>

  <div class="skeletor-req-list">
    <div class="skeletor-req-item">
      <div class="skeletor-req-item-head">
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <div class="skeletor-chip-row">
          <p-skeleton [width]="'7rem'" [height]="'1.4rem'" />
        </div>
      </div>
      <div class="skeletor-req-item-meta">
        <p-skeleton [width]="'10rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'10rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'16rem'" [height]="'0.9rem'" />
      </div>
    </div>
  </div>

  <div class="skeletor-req-subheader">
    <p-skeleton [width]="'14rem'" [height]="'1rem'" />
    <div class="skeletor-chip-row">
      <p-skeleton [width]="'9rem'" [height]="'1.4rem'" />
    </div>
  </div>

  <div class="skeletor-req-list">
    <div class="skeletor-req-item" *ngFor="let i of rows">
      <div class="skeletor-req-item-head">
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <div class="skeletor-req-actions">
          <p-skeleton shape="circle" [width]="'2rem'" [height]="'2rem'" />
          <p-skeleton shape="circle" [width]="'2rem'" [height]="'2rem'" />
        </div>
      </div>
      <div class="skeletor-req-item-meta">
        <p-skeleton [width]="'14rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'12rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'16rem'" [height]="'0.9rem'" />
      </div>
    </div>
  </div>
</div>

